import React from 'react';
import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react';
import clsx from 'clsx';

type Rule = {
  col: number;
  value: string;
  func: string;
};

type ListTableProps = {
  data: any[];
  columns: string[];
  rule: Rule[];
  sortConfig: { key: number; direction: 'asc' | 'desc' } | null;
  onSort: (columnIndex: number) => void;
};

export const ListTable = ({ data, columns, rule, sortConfig, onSort }: ListTableProps) => {
  const getSortIcon = (columnIndex: number) => {
    if (!sortConfig || sortConfig.key !== columnIndex) {
      return <ArrowUpDown className="w-4 h-4 opacity-50" />;
    }
    return sortConfig.direction === 'asc' 
      ? <ArrowUp className="w-4 h-4" />
      : <ArrowDown className="w-4 h-4" />;
  };

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            {columns.map((column, index) => (
              <th
                key={index}
                onClick={() => onSort(index)}
                className="group px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
              >
                <div className="flex items-center gap-2">
                  <span>{column}</span>
                  {getSortIcon(index)}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {data.map((row, rowIndex) => (
            <tr key={rowIndex} className="hover:bg-gray-50">
              {row.map((cell: any, cellIndex: number) => {
                const isHighlighted = rule.some(
                  r => r.col === cellIndex && r.func === '=' && cell === r.value
                );

                return (
                  <td
                    key={cellIndex}
                    className={clsx(
                      "px-6 py-4 whitespace-nowrap text-sm",
                      isHighlighted ? "bg-yellow-100 text-yellow-900" : "text-gray-900"
                    )}
                  >
                    {cell}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};